import Show from './src/show-combined';
export default Show;